import { ElementRef, ViewChild } from '@angular/core';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { Masks, MaskService } from 'src/app/shared/services/mask.service';
import { SearchPatientTotemRequest } from 'src/app/shared/services/requests/orchestrator-totem/search-patient-totem.request';
import { PatientFoundComponent } from './patient-found/patient-found.component';
import { PatientNotFoundComponent } from './patient-not-found/patient-not-found.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PatientArrivedEarlyLateModalComponent } from './patient-arrived-early-late-modal/patient-arrived-early-late-modal.component';
import { PatientWithoutSchedulingModalComponent } from './patient-without-scheduling-modal/patient-without-scheduling-modal.component';
import { UtilsClientService } from 'src/app/client/utils.service';
import { VerifyCPF } from 'src/app/shared/custom-validators/cpf.validator';
import { ClientGetPatientByCpfTotemService } from 'src/app/shared/services/API/orchestrator-totem/client-get-patient-by-cpf-totem.service';
import { TutorialPhotoModalComponent } from './tutorial-photo-modal/tutorial-photo-modal.component';
import { PhotoModalComponent } from './photo-modal/photo-modal.component';
import { OutdatedAddressModalComponent } from './outdated-address-modal/outdated-address-modal.component';
import { SendSmsEquipamentService } from 'src/app/shared/services/API/srv-email/send-sms-equipament.service';

@Component({
  selector: 'app-cpf-totem',
  templateUrl: './cpf-totem.component.html',
  styleUrls: ['./cpf-totem.component.css']
})
export class CpfTotemComponent implements OnInit {

  @Input() idHealthUnit: number | null = null;
  @Input() timeZoneValue: number | null = null;
  @Input() scheduled: boolean = false;
  @Input() hasFacialBiometrics: boolean = false;
  @Output() onCpfDefined: EventEmitter<string | number> = new EventEmitter<string | number>();
  @Output() onBack: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild("cpfInput", { static: true }) cpfInput!: ElementRef;

  constructor(
    private formBuilder: FormBuilder,
    private maskService: MaskService,
    private clientGetPatientByCpfTotemService: ClientGetPatientByCpfTotemService,
    private utilsClientService: UtilsClientService,
    private alertService: AlertService,
    public dialog: MatDialog,
  ) { }

  public model: FormGroup = this.formBuilder.group({});
  public masks: Masks = new Masks();
  public cpfCnsMask: any;
  public cpfMask: any;
  isLoading: boolean = false;
  public patientWithoutRegistration: number = 2;
  public arrivedEarly: number = 3;
  public arrivedLate: number = 4;
  formattedAddress: string = '';
  phoneMask: string = '';

  ngOnInit(): void {
    this.masks = this.maskService.getMasks();
    this.cpfCnsMask = this.masks.cpfCns;
    this.cpfMask = this.masks.cpf;
    this.model = this.formBuilder.group({
      cpfCns: ['', [Validators.required]],
    });
    this.setFocusOnCpfInput();

    if (this.scheduled) {
      this.model.get('cpfCns')!.setValidators([VerifyCPF(), Validators.required]);
      this.model.get('cpfCns')!.updateValueAndValidity();
    }
  }

  fowardWithoutCPF() {
    this.model.setValue({ cpfCns: '' });
    this.onCpfDefined.emit('');
  }

  back() {
    this.onBack.emit();
  }

  submit() {
    if (this.model.invalid || this.isLoading == true)
      return;

    let cns: string | null = null;
    let cpf: string | null = null;

    if (this.model.get('cpfCns')!.value.replace(/[^0-9]/g, '').replace(' ', '').length <= 11)
      cpf = this.model.get('cpfCns')!.value.replace(/[^0-9]/g, '').replace(' ', '');
    else
      cns = this.model.get('cpfCns')!.value.replace(/[^0-9]/g, '').replace(' ', '');

    if (!this.scheduled)
      this.searchByCpfCns(cpf!, cns!, null);
    else
      this.searchByCpfSchedule(cpf! ?? cns!);
  }

  searchByCpfCns(cpf: string | null, cns: string | null, imageResultRef: string | null) {
    this.isLoading = true;
    let request: SearchPatientTotemRequest = new SearchPatientTotemRequest();
    request.cpf = cpf;
    request.cns = cns;

    this.clientGetPatientByCpfTotemService.getClientPatientByCPF(this.idHealthUnit!, request, imageResultRef).subscribe({
      next: (response) => {
        if (response.isError && response.errorCode == 1) {
          this.openPatientNotFoundModal(imageResultRef != null);
        }
        else if (response.isError && response.errorCode == 2) {
          this.alertService.show('Atenção! ', response.errorDescription, AlertType.warning);
          this.openPatientNotFoundModal(imageResultRef != null);
        }

        else if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
        }
        else {
          this.formattedAddress = this.getFormattedAddress(response);
          this.phoneMask = this.getDisplayPhoneMask(response);
          this.openPatientFoundModal(response);
        }

        this.isLoading = false;
      },
      error: (error) => {
        console.log(error);
        this.isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  searchByCpfSchedule(cpf: string) {
    this.isLoading = true;
    let request: SearchPatientTotemRequest = new SearchPatientTotemRequest();
    request.cpf = cpf;

    this.clientGetPatientByCpfTotemService.getClientPatientScheduleByCPF(this.idHealthUnit!, this.timeZoneValue!, request).subscribe({
      next: (response) => {
        if (response.isError && response.errorCode == 1) {
          this.openPatientNotFoundModal();
        }

        else if (response.isError && response.errorCode == this.patientWithoutRegistration)
          this.openPatientWithoutSchedulingModal();

        else if (response.isError && response.errorCode == this.arrivedEarly)
          this.openPatientArrivedEarlyOrLateModal(this.arrivedEarly);

        else if (response.isError && response.errorCode == this.arrivedLate)
          this.openPatientArrivedEarlyOrLateModal(this.arrivedLate);

        else if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
        }
        else
          this.openPatientFoundModal(response);

        this.isLoading = false;
      },
      error: (error) => {
        console.log(error);
        this.isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  openPatientNotFoundModal(imageResultRef: boolean | null = null) {
    const dialogRef = this.dialog.open(PatientNotFoundComponent, {
      data: { imageResultRef }
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (imageResultRef && res) {
        this.openFacialBiometrics();
      }
    });
  }

  openPatientFoundModal(patient: any) {
    this.utilsClientService.setIdUserPatientSchedule(patient.idUserPatient);
    this.utilsClientService.setIdSchedule(patient.idSchedule);
    const dialogRef = this.dialog.open(PatientFoundComponent, {
      data: {
        patient: patient,
        formattedAddress: this.formattedAddress,
        phoneMask: this.phoneMask
      }
    });
    dialogRef.afterClosed().subscribe({
      next: (res: any) => {
        if (res)
          this.onCpfDefined.emit(patient);
        else if (res === false)
          this.openOutdatedAddressModal(patient);
        else {
          this.model.setValue({ cpfCns: '' });
          this.setFocusOnCpfInput();
        }
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  openPatientArrivedEarlyOrLateModal(arrived: number) {
    const dialogRef = this.dialog.open(PatientArrivedEarlyLateModalComponent, {
      data: {
        arrived: arrived,
      },
      panelClass: "totem-modal",
    });
    dialogRef.afterClosed().subscribe({
      next: (res: any) => {
        this.back();
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  openOutdatedAddressModal(patient: any) {
    const dialogRef = this.dialog.open(OutdatedAddressModalComponent, {
      data: {
        patient: patient,
        formattedAddress: this.formattedAddress,
        phoneMask: this.phoneMask
      },
      panelClass: "totem-modal",
    });
    dialogRef.afterClosed().subscribe({
      next: (res: any) => {
        if (res?.patient)
          this.onCpfDefined.emit(res.patient);
        else
          this.openPatientFoundModal(patient);
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  openPatientWithoutSchedulingModal() {
    const dialogRef = this.dialog.open(PatientWithoutSchedulingModalComponent, {
      panelClass: "totem-nps-modal",
    });
    dialogRef.afterClosed().subscribe({
      next: (res: any) => {
        this.back();
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  private setFocusOnCpfInput() {
    setTimeout(() => {
      this.cpfInput.nativeElement.focus();
    }, 0);
  }

  openFacialBiometrics() {
    const dialogRef = this.dialog.open(TutorialPhotoModalComponent);
    dialogRef.afterClosed().subscribe({
      next: (res: any) => {
        if (res === true) {
          const dialogRef1 = this.dialog.open(PhotoModalComponent);
          dialogRef1.afterClosed().subscribe({
            next: (res1: any) => {
              if (res1 && res1.imageResultRef) {
                this.searchByCpfCns(null, null, res1.imageResultRef);
              }
            },
            error: (error) => {
              console.log(error);
            }
          });
        }
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  getFormattedAddress(patient: any): string {
    const parts = [
      patient.street,
      patient.houseNumber,
      patient.apartmentNumber,
      patient.neighborhood,
      patient.zipCode
    ];

    let cityState = '';
    if (patient.city && patient.state)
      cityState = `${patient.city} - ${patient.state}`;
    else if (patient.city)
      cityState = patient.city;
    else if (patient.state)
      cityState = patient.state;

    if (cityState)
      parts.push(cityState);

    return parts.filter(part => !!part).join(', ');
  }

  getDisplayPhoneMask(patient: any): string {
    if (patient.phone1 || patient.phone2) {
      const fone = patient.phone1 ?? patient.phone2;
      if (fone) {
        const justDigits = fone.replace(/\D/g, '');

        const lastFour = justDigits.slice(-4);

        return `(**) *****-${lastFour}`;
      }
    }
    return '';
  }
}